import React from 'react';

import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import gtmTracker from '@utils/gtmTracker';

import useEnglishTranslation from '@hooks/use-english-translation';

import { PromotionType } from '@types';

import { Button } from '@components/button';

import * as Styled from './completed-promotion-card.styled';

type OwnProps = {
	promo: PromotionType;
};

const CompletedPromotionCard: React.FC<OwnProps> = ({ promo }) => {
	const { t } = useTranslation('main');
	const tEn = useEnglishTranslation('main');
	const navigate = useNavigate();

	const handleButtonClick = (id: string) => {
		gtmTracker.trackEvent('click', {
			event_category: 'Promotions',
			event_action: 'click',
			event_label: tEn('results')
		});
		navigate('/completed-promotion/' + id, { state: { promotionId: id } });
	};

	return (
		<Styled.Wrapper $bg={promo.image}>
			<Styled.Content>
				<Styled.Title>{promo.name}</Styled.Title>
				<Styled.EndDate>{t('ended_status') + ': ' + dayjs(promo.end_date).format('DD.MM.YYYY')}</Styled.EndDate>
				<Button onClick={() => handleButtonClick(promo.id)} color='dark'>
					{t('results')}
				</Button>
			</Styled.Content>
		</Styled.Wrapper>
	);
};

export default CompletedPromotionCard;
